import {inject, Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {CustomerDocument} from '../../interfaces/customer-documents/customer-document';
import {db} from '../db.service';
import {CustomerDocumentFactory} from '../../factories/customer-documents/customer-document-factory';
import {CustomerDocumentsAdapter} from '../../adapters/customer-documents.adapter';
import {DocumentsService} from '../../services/core/documents.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerDocumentsTable extends SyncTable<CustomerDocument> {

  private readonly _documentsService: DocumentsService;

  constructor() {
    super(db.customerDocuments);
    this._documentsService = inject(DocumentsService);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new CustomerDocumentsAdapter({
        api: ['customer-documents'],
        fromObject: CustomerDocumentFactory.fromObject,
        toRemote: CustomerDocumentFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<CustomerDocument[]> {
    return this.table.where('customerId').equals(customerId).toArray();
  }

  /**
   *
   * @param customerIds
   */
  public async getByCustomerIds(customerIds: number[]): Promise<CustomerDocument[]> {
    return this.table.where('customerId').anyOf(customerIds).toArray();
  }

  /**
   * Removes the given documents including their files on the filesystem.
   * Files are deleted outside the transaction (not allowed inside).
   *
   * @param customerDocuments
   */
  public async removeManyWithFiles(customerDocuments: CustomerDocument[]): Promise<void> {
    if(customerDocuments.length <= 0) {
      return;
    }

    for(const customerDocument of customerDocuments) {
      try {
        await this._documentsService.deleteDocument(customerDocument.file);
      }
      catch(error) {
        console.warn('Could not delete customer document file:', error);
      }
    }

    await this.removeMany(customerDocuments.map(({ uuid }) => uuid), true);
  }

  /**
   *
   */
  public override async clear(): Promise<void> {
    const customerDocuments = await this.table.toArray();
    for(const customerDocument of customerDocuments) {
      await this._documentsService.deleteDocument(customerDocument.file);
    }
    await super.clear();
  }


}